import React from 'react';
import {createRoot} from 'react-dom/client';
import { Provider } from 'react-redux';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import * as icons from '@coreui/icons/js/free';
import { BrowserRouter } from 'react-router-dom';
import 'react-dates/initialize';
import configureStore from './store';
import App from './app/App';

import 'react-dates/lib/css/_datepicker.css';
import './scss/style.scss';
import 'react-phone-number-input/style.css';
import { injectStore } from './shared/services/axios-interceptors';
import './tailwind.css';

// @ts-ignore
React.icons = icons;

const store = configureStore();
injectStore(store);


window.Chargebee.init({
  site: process.env.CHARGEBEE_SITE,
  isItemsModel: true,
  enableGTMTracking: true,
});


(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.LAUNCHDARKLY_ID,
    context: {
      key: 'anonymous-user-key',
      name: 'anonymous-user-name'
    },
  });

  const root = createRoot(document.getElementById('root'));

  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <LDProvider>
          <App />
          <div id="mapContainer" />
        </LDProvider>
      </BrowserRouter>
    </Provider>,
  );

  // Enable hot reload for module and it's dependencies
  if (module.hot) {
    module.hot.accept();
  }
})();
